/**
 * Workspace card grids use a floating footer (no outer tile frame), so row
 * gap is taller than column gap — footers need room without crowding.
 */
export const workspaceCardGridGapClassName = "gap-x-4 gap-y-8";

/** Canvas / chat recents — 286px tile track. */
export const workspaceCanvasCardGridClassName = `grid grid-cols-[repeat(auto-fill,minmax(min(286px,100%),1fr))] ${workspaceCardGridGapClassName}`;

/** Chats tab — fixed 286px columns. */
export const workspaceChatCardGridClassName = `grid grid-cols-[repeat(auto-fill,286px)] ${workspaceCardGridGapClassName}`;

/** Files tab — denser 220px track. */
export const workspaceFileCardGridClassName = `grid grid-cols-[repeat(auto-fill,minmax(min(220px,100%),1fr))] ${workspaceCardGridGapClassName}`;

/** Workspace index tiles — 300px track. */
export const workspaceListCardGridClassName = `grid grid-cols-[repeat(auto-fill,minmax(min(300px,100%),1fr))] ${workspaceCardGridGapClassName}`;

/** Storybook overview — slightly wider track for mixed card families. */
export const workspaceStorybookCardGridClassName = `grid grid-cols-[repeat(auto-fill,minmax(min(280px,100%),1fr))] ${workspaceCardGridGapClassName}`;
